import {
  ColorScheme,
  DEFAULT_THEME,
  ThemeName,
  ThemeVariant,
} from '@toggle/design-system';
import { Entity } from '@toggle/toggle';

import {
  THEME_NAME_STORAGE_KEY,
  useRemoteStorage,
} from '~/hooks/use-remote-storage';
import { create } from '~/utils/store/createStore';

import {
  createThemeName,
  getValidThemeName,
  isDarkTheme,
  splitThemeName,
} from '../utils/theme-utils/theme-utils';

interface ThemeStore {
  themeName: ThemeName;
  colorScheme: ColorScheme;
  initStore: () => void;
  changeTheme: (colorScheme: ColorScheme, themeVariant: ThemeVariant) => void;
  getThemedLogoUrl: (entity: Entity) => string;
}

export const useThemeStore = create<ThemeStore>((set, get) => ({
  themeName: DEFAULT_THEME,
  colorScheme: splitThemeName(DEFAULT_THEME).colorScheme,
  initStore: () => {
    const { items } = useRemoteStorage.getState();
    const themeName = getValidThemeName(items?.[THEME_NAME_STORAGE_KEY]);
    const { colorScheme } = splitThemeName(themeName);

    set({
      themeName,
      colorScheme,
    });
  },
  changeTheme: (colorScheme, themeVariant) => {
    const { storeItems } = useRemoteStorage.getState();
    const themeName = createThemeName(colorScheme, themeVariant);

    set({
      themeName,
      colorScheme,
    });

    storeItems({
      [THEME_NAME_STORAGE_KEY]: themeName,
    });
  },
  getThemedLogoUrl: (entity: Entity) => {
    const isDark = isDarkTheme(get().themeName);
    return isDark ? entity.logo_urls.light_png : entity.logo_urls.dark_png;
  },
}));
